/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { OrbitTokenRegistry } from "../OrbitTokenRegistry";

export class OrbitTokenRegistry__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<OrbitTokenRegistry> {
    return super.deploy(overrides || {}) as Promise<OrbitTokenRegistry>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): OrbitTokenRegistry {
    return super.attach(address) as OrbitTokenRegistry;
  }
  connect(signer: Signer): OrbitTokenRegistry__factory {
    return super.connect(signer) as OrbitTokenRegistry__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): OrbitTokenRegistry {
    return new Contract(address, _abi, signerOrProvider) as OrbitTokenRegistry;
  }
}

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "TokenAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "TokenRemoved",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "add",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "enabled",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
    ],
    name: "remove",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";
